module.exports = __webpack_public_path__ + "d4811c278d659bb33f910685dd356ad8.svg";